import React, { useMemo } from "react";

import { IconButton } from "@mui/material";
import { AppBadge } from "Components/AppBadge";
import { ArrowDown2 as IconArrowDown } from "iconsax-react";
import { useTranslation } from "react-i18next";
import { ResourceViewerOptions, TaskStatus } from "Util/enums";

import { useOperationDespatchContext } from "../../../../contexts/DespatchContext";
import {
  Menu,
  MenuItem,
  MenuItemLabel,
  MenuItemLabelIndicator,
  ResourceTaskPublishFilterContainer,
  ResourceTaskPublishFilterLabel,
} from "./styled";
import { PUBLISHED_TASKS, UNPUBLISHED_TASKS } from "./types";

export const DespatchTaskPublishFilters = () => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { t: translate } = useTranslation();
  const { setDespatchGlobalFilters, despatchGlobalFilters, taskStatusCounter, selectedOption } =
    useOperationDespatchContext();

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleChoseOption = (options?: TaskStatus[] | null) => {
    handleClose();
    setDespatchGlobalFilters({ ...despatchGlobalFilters, tasksStatuses: options });
  };

  const currentOption = useMemo(() => {
    if (!despatchGlobalFilters.tasksStatuses || !despatchGlobalFilters.tasksStatuses.length) {
      return "allTasks";
    }

    if (despatchGlobalFilters.tasksStatuses.includes(TaskStatus.WAITING_PUBLISH))
      return "unpublishedTasks";

    return "publishedTasks";
  }, [despatchGlobalFilters]);

  const nameDictionary = {
    allTasks:
      selectedOption === ResourceViewerOptions.TEAM ? translate("allTeams") : translate("allTasks"),
    unpublishedTasks:
      selectedOption === ResourceViewerOptions.TEAM
        ? translate("teamsWithUnpublishedTasks")
        : translate("unpublishedTasks"),
    publishedTasks:
      selectedOption === ResourceViewerOptions.TEAM
        ? translate("teamsWithPublishedTasks")
        : translate("publishedTasks"),
  };

  const currentTasksCount = useMemo(() => {
    return taskStatusCounter[currentOption];
  }, [taskStatusCounter, currentOption]);

  return (
    <>
      <ResourceTaskPublishFilterContainer>
        <ResourceTaskPublishFilterLabel>
          <div>{nameDictionary[currentOption]}</div>

          <AppBadge variant="gray">{currentTasksCount}</AppBadge>
        </ResourceTaskPublishFilterLabel>

        <IconButton onClick={handleClick}>
          <IconArrowDown size={20} />
        </IconButton>
      </ResourceTaskPublishFilterContainer>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose} elevation={2}>
        <MenuItem onClick={() => handleChoseOption()} active={currentOption === "allTasks"}>
          <MenuItemLabel>{nameDictionary.allTasks}</MenuItemLabel>
          <MenuItemLabelIndicator>{taskStatusCounter.allTasks}</MenuItemLabelIndicator>
        </MenuItem>

        <MenuItem
          onClick={() => handleChoseOption(UNPUBLISHED_TASKS)}
          active={currentOption === "unpublishedTasks"}
        >
          <MenuItemLabel>{nameDictionary.unpublishedTasks}</MenuItemLabel>
          <MenuItemLabelIndicator>{taskStatusCounter.unpublishedTasks}</MenuItemLabelIndicator>
        </MenuItem>

        <MenuItem
          onClick={() => handleChoseOption(PUBLISHED_TASKS)}
          active={currentOption === "publishedTasks"}
        >
          <MenuItemLabel>{nameDictionary.publishedTasks}</MenuItemLabel>
          <MenuItemLabelIndicator>{taskStatusCounter.publishedTasks}</MenuItemLabelIndicator>
        </MenuItem>
      </Menu>
    </>
  );
};
